/* Const,Let & Var will be here */
export const HISTORY = 'HISTORY';
/* Const,Let & Var will be here */

export function onHistorySave(history) {
    return {
        type: HISTORY,
        history: history
    };
}